export default __webpack_public_path__ + "8a0ff345d64225a2383d29650d46ebfd.png";